import Application from './flow/Application'

export class App extends Application {} 